import BaseService from "./BaseService";

class LearningMilestoneService {
  static async list(data) {
    const params = (data && BaseService.cleanQueryParams(data)) || {};
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(`/learning-milestones?${queryParams}`);
  }

  static async create(data) {
    return await BaseService.callAPI(`/learning-milestones`, "POST", data);
  }

  static async details({ id }) {
    return await BaseService.callAPI(`/learning-milestones/${id}`);
  }

  static async update({ id, payload }) {
    return await BaseService.callAPI(
      `/learning-milestones/${id}`,
      "POST",
      payload
    );
  }
}

export default LearningMilestoneService;
